import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "-mx-16 h-16 shadow-custom-cart-drawer tablet:-mx-24"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.cartHasItems)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, "   "))
    : _createCommentVNode("", true)
}